import { SCREEN_MD } from 'styles/b4b-theme';

export default document && document.body && document.body.clientWidth < SCREEN_MD;
